
// const getBaseUrl = () => {
//   if (process.env.REACT_APP_ENV_MODE === 'development') {
//     return process.env.REACT_APP_API_URL_DEV + "/api";
//   } else if (process.env.REACT_APP_ENV_MODE === 'test') {
//     return process.env.REACT_APP_API_URL_TEST + "/api";
//   } else if (process.env.REACT_APP_ENV_MODE === 'production') {
//     return process.env.REACT_APP_API_URL_PROD + "/api";
//   } else {
//     return "http://localhost:5000/api"; // ברירת מחדל
//   }
// };

const getBaseUrl = () => {
    return "/api";
};

const year = 'תשפז';

function formatHebrewYear(year: string): string {
  if (year.length < 2) return year;
  const prefix = year.slice(0, -1); // כל האותיות חוץ מהאחרונה
  const lastChar = year.slice(-1); // האות האחרונה
  return `${prefix}"${lastChar}`;
}

const appConfig = {
  version: "0.0.1",
  apiUrls: {
    baseUrl: getBaseUrl(),

    //newFormUrl: function() { return `${this.baseUrl}/newForm`; },
  },

  price: '1250',
  year: year,
  formattedYear: formatHebrewYear(year),
  recurStartDate: "2026-09-10",

  accounts: {
    lodBuses: {
      namespace: 'הסעות לוד',
      accountId: '5154700000058279546',
      mosadId: '5154700000058279866',
    }
  },

  zoho: {
    schedulingRecordUrl: (recordId: string) =>
      `https://crm.zoho.com/crm/org768376871/tab/CustomModule2/${recordId}`,
  },


  authorities: [
    {
      en: 'lod',
      he: 'לוד',
      tranzilaCode: 'lodhtz',
      tranzilaCodeTok: 'lodhtz',
    },
  ],
//בשימוש
  checkIdUrl: "https://hook.eu1.make.com/1w66i7f7qd8j6souxqxt7rklyzxq62av",
  dataUrl: "https://hook.eu1.make.com/kj4s5kwum4fhg84gvatdjgzd1sk7g3x6",
  //לא בשימוש כרגע
  tempPaymentUrl: "https://hook.eu1.make.com/xlk9b7ttr53hv5dywt1fr1smt79x4yep",
  cashOrCheckPaymentUrl: "https://hook.eu1.make.com/nct7vqg7uh37hprvafm5cfqjcbv9vhfg",



  service: function() {
    return `
      office@htz-tech.co.il <i class="fas fa-envelope"></i>  פנייה לשירות לקוחות בווטסאפ:  
       <i class="fab fa-whatsapp"></i>  058-5511320 
        
    `;
  },
  
  

  is_mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
};


export default appConfig;


